<template>
    <div id="communication-menu">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item active">Comunicación</li>
            </ol>
        </nav>
        <div class="container-fluid">
            <div class="row">
                <vs-divider>HERRAMIENTAS</vs-divider>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center feedback">
                        <vs-button @click="$router.push('/admon/feedback')" type="line" size="large">Retroalimentación</vs-button>
                    </vx-card>
                </div>

              <div class="col-sm-12 col-md-6 col-lg-3">
                <vx-card class="text-center investorsPrograms">
                  <vs-button @click="$router.push('/emails/campaigns')" type="line" size="large">Campañas <br>Promocionales</vs-button>
                </vx-card>
              </div>

                <vs-divider>PLANTILLAS</vs-divider>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center">
                        <vs-button   @click="$router.push('/admon/templates/email')" type="line" size="large">Correos</vs-button>
                    </vx-card>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center">
                        <vs-button   @click="$router.push('/admon/templates/slack')" type="line" size="large">Slack</vs-button>
                    </vx-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .vx-card {
        cursor: pointer !important;
        margin-bottom: 1rem !important;
        min-height: 6.5rem !important;
    }

    .feedback button {
        padding: 14px !important;
        padding-left: 5px !important;
    }
    .investorsPrograms button {
        padding: 5.5px !important;
    }
</style>
